<div [class]="(disabled ? 'disabled ' : '') + 'chip-wrapper'">
	<p>{{ labelInput }}</p>
	@if (onDelete) {
		<mat-icon class="material-icons-outlined icon" (click)="handleDelete($event)">clear</mat-icon>
	}
</div>
